import { createStore, combineReducers, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import user from './user';
import products from './products';
import cartItems from './cartItems';

const reducer = combineReducers({ user, products, cartItems });

const middlewareList = [thunkMiddleware];
if (process.env.NODE_ENV !== 'production') {
  middlewareList.push(createLogger({ collapsed: true }));
}

const enhancer =
  process.env.NODE_ENV !== 'production'
    ? composeWithDevTools(applyMiddleware(...middlewareList))
    : applyMiddleware(...middlewareList);

const store = createStore(reducer, enhancer);

export default store;
export * from './user';
export * from './products';
export * from './cartItems';
